/**
 * 车辆里程实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-08
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    message,
    InputNumber,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '车辆里程';
const { Text } = Typography;

const Entity = (props) => {
    const { open, setOpen, record, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [currentMileage, setCurrentMileage] = useState(1);

    const cancel = () => {
        setOpen(false);
        setLoading(false);
    };

    useEffect(() => {
        if (record) {
            setCurrentMileage(record.current_mileage);
        }
    }, [record]);

    const ok = () => {
        console.log(currentMileage - record.current_mileage);
        //  参数校验
        if (currentMileage <= record.current_mileage || currentMileage - record.current_mileage > 10000) {
            messageApi.error('车牌里程录入错误！');
            return;
        }
        setLoading(true);

        $.ajax({
            url: `${CNF.api}cars/${props.record.key}/mileage`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                add_mileage: currentMileage - props.record.current_mileage,
                current_mileage: currentMileage,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={350}
                title={'修改' + MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical>
                    <Text>当前里程<Text type='danger'>*</Text></Text>
                    <InputNumber
                        suffix='km'
                        min={record?.current_mileage}
                        step={1}
                        style={{ width: '100%' }}
                        value={currentMileage}
                        onChange={(value) => setCurrentMileage(value)}
                        disabled={loading}
                    />
                </Flex>
            </Modal>
        </>
    );
}

export default Entity